import { motion } from "framer-motion";
import { Phone, MoveRight, BatteryCharging, Sun, Satellite, Zap } from "lucide-react";
import { IMAGES, PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const TAGS = [
  { icon: Sun, label: "Solar" },
  { icon: BatteryCharging, label: "Lithium batteries" },
  { icon: Zap, label: "DC-DC charging" },
  { icon: Satellite, label: "Starlink installs" },
];

export const Roamwire = () => (
  <section
    id="roamwire"
    data-testid="roamwire-funnel-card"
    className="relative py-20 sm:py-28 lg:py-32 overflow-hidden"
  >
    {/* backdrop */}
    <div className="absolute inset-0">
      <img
        src={IMAGES.lithium}
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover opacity-20"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ink/80" />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, #0B0F17 0%, rgba(11,15,23,0.55) 30%, rgba(11,15,23,0.55) 70%, #0B0F17 100%)",
        }}
      />
    </div>

    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
      <div className="rounded-3xl border border-amber-500/40 bg-[rgba(18,24,36,0.75)] backdrop-blur-xl p-8 sm:p-12 lg:p-16 shadow-[0_0_120px_rgba(245,158,11,0.12)]">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2.5 rounded-full border border-amber-500/50 bg-amber-500/10 px-4 py-2 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.24em] text-amber-300 font-semibold"
        >
          <span className="relative flex w-2 h-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-400" />
          </span>
          Roamwire — off-grid touring division · launching soon
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          data-testid="roamwire-heading"
          className="font-display font-bold uppercase tracking-tight text-slate-50 text-3xl sm:text-5xl lg:text-6xl leading-[0.95] mt-8 max-w-3xl"
        >
          Touring setups? Off-grid builds?{" "}
          <span className="text-amber-500">That's Roamwire.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-6 max-w-2xl text-slate-300 text-base sm:text-lg leading-relaxed"
        >
          Solar, lithium batteries, DC-DC charging, Starlink installs and full
          off-grid canopy and caravan systems — that's a whole other part of
          what we do, and it's getting its own dedicated home. Roamwire is
          launching soon.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-6"
        >
          <a
            href={PHONE_TEL}
            data-testid="roamwire-cta-btn"
            className="inline-flex items-center justify-center gap-2.5 h-14 px-8 rounded-full bg-amber-500 hover:bg-amber-400 text-ink font-bold text-base transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(245,158,11,0.35)]"
          >
            <Phone size={18} strokeWidth={2.5} />
            Call Sam in the meantime — {PHONE_DISPLAY}
          </a>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400 flex items-center gap-2">
            Touring &amp; off-grid jobs still taken by phone
            <MoveRight size={14} className="text-amber-400" />
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 pt-8 border-t border-line/70 flex flex-wrap gap-x-8 gap-y-4"
        >
          {TAGS.map((t) => (
            <span
              key={t.label}
              className="inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300"
            >
              <t.icon size={15} className="text-amber-400" />
              {t.label}
            </span>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
